<template>
  <div
    class="input-number"
    :class="getTypeClasses">
    <label :for="id">
      {{label}}
    </label>
    <div class="input-wrapper">
      <input :id="id" type="number" :title="label" v-bind="$attrs" v-on="$listeners" />
      <span class="unit">{{unit}}</span>
      <div class="footnote" v-if="footnote != ''">{{footnote}}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.input-number {
  display: flex;
  label {
    flex: 0 0 10rem;
  }
  input {
    flex: 1 1 100%;
    width: 100%;
  }
  &.vertical {
    flex-direction: column;
    label {
      font-size: var(--text--xs);
      flex: 0 0 auto;
    }
  }
  &.row {
    flex-direction: column;
    label {
      visibility: hidden;
      height: 0;
    }
  }
  &.nolabel {
    label {
      display: none;
    }
  }
}

.footnote {
  @extend %text-style--label;
  font-size: var(--text--xs);
  color: var(--color--secondary);
  position: absolute;
  left: 0;
  top: $spacing--l + $spacing--xxs;
}

.input-wrapper {
  position: relative;
}

.unit {
  @extend %text-style--label;
  font-size: var(--text--xxs);
  color: var(--color--secondary);
  position: absolute;
  right: $spacing--xxs;
  top: $spacing--xs;
}

[class="input-number"] {
  @extend %form-row;
  align-items: center;
}

</style>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default () {
        return uuid()
      }
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: ''
    },
    footnote: {
      type: String,
      default: ''
    }
  },
  computed: {
    getTypeClasses () {
      switch (this.type) {
        case 'vertical':
          return 'vertical'
        case 'row':
          return 'row'
        case 'nolabel':
          return 'nolabel'
        default:
          return ''
      }
    }
  }
}
</script>
